<template>
  <v-card>
    <v-img
      :src="this.$config.gallery + '/' + gallery.path + '/' + gallery.src"
      height="200"
    >
      <router-link :to="{ name: 'Gallery', params: { path: gallery.path }}">
        <v-hover>
          <template v-slot="{ hover }">
            <v-overlay
              :color="hover ? 'white' : 'black'"
              absolute
              class="align-end pa-3 justify-start"
              opacity=".2"
            >
              <v-btn
                color="#252525"
                dark
                small
              >
                {{ gallery.category }}
              </v-btn>
            </v-overlay>
          </template>
        </v-hover>
      </router-link>
    </v-img>

    <div class="px-3 pb-4">
      <v-card-title
        class="headline font-weight-bold mb-2"
        v-text="gallery.title"
      />

      <v-card-text class="body-1 grey--text text-darken-2">
        <div
          class="mb-4"
          v-text="gallery.date"
        />

        <div v-text="gallery.blurb" />
      </v-card-text>
    </div>
  </v-card>
</template>

<script>
  export default {
    name: 'GalleryCard',

    props: {
      gallery: {
        type: Object,
        default: () => ({
          path: undefined,
          category: undefined,
          date: undefined,
          blurb: undefined,
          src: undefined,
          title: undefined,
        }),
      },
    },
  }
</script>
